import useModalTrigger from 'magik-react-hooks/useModalTrigger'
import { Link } from 'react-router-dom'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import Header from '../../components/Header'
import Page from '../../components/Page'
import Sorter, { SortControl } from '../../components/Sorter'
import StickyTable from '../../components/StickyTable'
import { useQsFilters } from '../../hooks/filters'
import {
  useBibliografie,
  useDeleteBibliografia,
} from '../../hooks/bibliografie'
import { Bibliografia } from '../../types'

const initFilters = (params: URLSearchParams) => ({
  page: Number(params.get('page') ?? 1),
  ordering: params.get('ordering') ?? '',
  search: params.get('search') ?? '',
})

export default function BibliografieList() {
  const { filters, uiFilters, setFilters, setFiltersDebounced } =
    useQsFilters(initFilters)
  const { data } = useBibliografie(filters)
  const deleteBibliografia = useDeleteBibliografia()
  const [modalRm, modalRmActions] = useModalTrigger<Bibliografia>()

  return (
    <Page padded>
      <Header>
        <div className="d-flex align-items-end">
          <h2 className="m-0">Bibliografie</h2>
        </div>
        <Link className="btn btn-primary" to="/bibliografie/new">
          <i className="bi bi-plus-circle me-2"></i> Aggiungi
        </Link>
      </Header>
      <div className="d-flex justify-content-between mt-3 mb-3 align-items-center">
        <input
          placeholder="Cerca"
          className="form-control w-auto"
          type="text"
          value={uiFilters.search}
          onChange={(e) =>
            setFiltersDebounced({ search: e.target.value, page: 1 })
          }
        />
      </div>
      <StickyTable className="flex-1">
        <Sorter
          value={uiFilters.ordering}
          onSortChange={(ordering) =>
            setFilters({
              ordering,
              page: 1,
            })
          }
        >
          <thead>
            <tr>
              <th>#</th>
              <th>
                <div className="d-flex align-items-center">
                  Descrizione
                  <SortControl field={'nome'} />
                </div>
              </th>
              <th>
                <div className="d-flex align-items-center">
                  Cognome
                  <SortControl field={'cognome'} />
                </div>
              </th>
              <th>
                <div className="d-flex align-items-center">
                  Presente in pagina pubblicazione
                  <SortControl field={'pagina_pubblicazione'} />
                </div>
              </th>

              <th></th>
            </tr>
          </thead>
        </Sorter>
        <tbody>
          {data!.results.map((biblio) => (
            <tr key={biblio.id}>
              <td>{biblio.id}</td>
              <td>
                <Link to={`/bibliografie/${biblio.id}`}>
                  {biblio.descrizione_plain}
                </Link>
              </td>
              <td>{biblio.cognome}</td>
              <td>{biblio.pagina_pubblicazione ? 'Si' : 'No'}</td>
              <td>
                <i
                  onClick={() => modalRmActions.open(biblio)}
                  className="bi cursor-pointer text-danger bi-trash3-fill"
                ></i>
              </td>
            </tr>
          ))}
        </tbody>
      </StickyTable>
      <Modal centered isOpen={modalRm.isOpen} toggle={modalRmActions.toggle}>
        <ModalHeader toggle={modalRmActions.toggle}>Elimina</ModalHeader>
        <ModalBody>
          {modalRm.value && (
            <div className="pt-3 pb-3">
              Sei sicuro di voler eliminare la bibliografia{' '}
              {modalRm.value.descrizione_plain} ?
            </div>
          )}
        </ModalBody>
        <ModalFooter className="d-flex justify-content-between">
          <button
            onClick={modalRmActions.toggle}
            className="btn btn-outline-primary"
          >
            Annulla
          </button>
          <button
            className="btn  btn-danger"
            disabled={deleteBibliografia.isLoading}
            onClick={async () => {
              await deleteBibliografia.mutateAsync(modalRm.value!.id)
              modalRmActions.close()
            }}
          >
            <i className="bi bi-trash3-fill"></i> Elimina
          </button>
        </ModalFooter>
      </Modal>
      <div className="position-relative"></div>
    </Page>
  )
}
